export default {
  title: "الملاحق والإصدارات",
  entityName: "category",
  properties: [
    {
      text: "#UID",
      value: "id",
      align: "right",
      field: "_id",
      sortable: false,
    },
    {
      text: "الملاحق",
      value: "category",
      align: "right",
      field: "_category",
      sortable: false,
    },
  ],
  getHeader() {
    let newArr = [];

    this.properties.forEach(({ text, value, align, sortable }) => {
      newArr.push({ text, value, align, sortable });
    });

    return newArr;
  },
  getSortDropdown() {
    let newArr = [];

    this.properties.forEach(({ text, field }) => {
      newArr.push({ text, field });
    });

    return newArr;
  },
};
